import type { FC } from 'react';
import { useEffect } from 'react';
import {
  PageLoginBody,
  PageLoginHeader,
} from '@components/PagesFragments/Login/index';
import { LoaderFullPage } from '@app/loaders/LoaderFullPage';
import { redirectTo } from '@utils/routing';

export const PageLogin: FC = () => {
  const token = localStorage.getItem('token');

  const redirectPage =
    localStorage.getItem('EmployerView::authRedirectPath') ||
    `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/`;

  useEffect(() => {
    if (token) {
      redirectTo(redirectPage);
    }
  }, [token]);

  return token ? (
    <LoaderFullPage />
  ) : (
    <div className="c-page-login">
      <PageLoginHeader />
      <PageLoginBody />
    </div>
  );
};
